export const selectedCourseValueTextMapper: { [key: string]: string } = {
    POST_GRADUATE_DIPLOMA: "PG Diploma",
    MASTERS: "Masters",
    UNDER_GRADUATION: "UG course",
    MBA: "MBA",
    PHD: "PHD",
    NOT_DECIDED: "Course not decided",
  };

export const selectedIntakeValueTextMapper: { [key: string]: string } = {
    SEPTEMBER_2021: "Sept 2021",
    JANUARY_2022: "Jan 2022",
    YEAR_2024: "Year 2024",
    YEAR_2023: "2023",
  };

  export const intakeValueToLabel : any = {
    "JAN_2023": "January 2023",
    "SEP_2023": "September 2023",
    "YEAR_2024": "Year 2024",
    "JAN_2024":"January 2024",
    "SEP_2024": "September 2024"
  };

  export const intakeValueToLabelDynamic : any = {
    "JAN": "January",
    "SEP": "September",
    "MAY" : "May",
    "NOVEMBER" : "November",
    "JULY" : "July",
    "FEBRUARY" : "February"
  };

  export const anyCountryToValueCountry : any = {
    "canada": "Canada",
    "Canada": "Canada",
    "CANADA" : "Canada",
    "Ireland": "Ireland",
    "ireland": "Ireland",
    "IRELAND": "Ireland",
    "Australia":"Australia",
    "australia":"Australia",
    "AUSTRALIA":"Australia",
    "UK":"UK",
    "uk":"UK",
    "Uk":"UK",
    "USA":"USA",
    "usa":"USA",
    "Uas":"USA",
    "Other":"Other",
    "other":"Other",
    "OTHER":"Other"
  };